let uid = 0

export default function () {
  uid++
  return uid
}
